import ModalPanel from '@admin/components/modal_panel'
import Message from '@admin/components/message'
import PropTypes from 'prop-types'
import React from 'react'

class Complete extends React.Component {

  static propTypes = {
    onDone: PropTypes.func
  }

  _handleDone = this._handleDone.bind(this)

  render() {
    return (
      <ModalPanel { ...this._getPanel() }>
        <Message { ...this._getMessage() } />
      </ModalPanel>
    )
  }

  _getPanel() {
    return {
      title: 't(Importing Complete)'
    }
  }

  _getMessage() {
    return {
      title: 't(Import Successful!)',
      text: 't(Great job! Your data was imported successfully)',
      svg: 'check',
      color: 'green',
      animation: 'tada',
      button: {
        label: 't(Finish)',
        handler: this._handleDone
      }
    }
  }

  _handleDone() {
    this.props.onDone()
  }

}

export default Complete
